export const getJustifyContent = (direction, horizontalAlign, verticalAlign) => {
    const horizontalMap = {
        left: 'flex-start',
        center: 'center',
        right: 'flex-end',
        spaceBetween: 'space-between',
        none: 'normal',
    };
    const verticalMap = {
        top: 'flex-start',
        center: 'center',
        bottom: 'flex-end',
        spaceBetween: 'space-between',
        none: 'normal',
    };
    return direction === 'column'
        ? verticalMap[verticalAlign]
        : horizontalMap[horizontalAlign];
};
